// extracted by mini-css-extract-plugin
module.exports = {"subMenuList":"subMenuList-hInjN","newSubMenuLabel":"newSubMenuLabel-JJcux","subMenuItem":"subMenuItem-9C05T","subMenuLink":"subMenuLink-1WLxI"};